<template>
    <section class="" :class="wrapperClass">
        <p :class="textClasses" style="text-align:center">
            {{$t('vue.checkout.checkoutLoginRegister.new')}} <br />
            <strong>
                {{$t('vue.forms.register.registerNow')}}
            </strong>
            <br>
            {{$t('vue.forms.register.message')}}
          <br /> <br />
        </p>

        <a :href="newCustomerUrl"
           class="btn btn-primary my-3">{{$t('vue.forms.register.newAccount')}}</a>
    </section>
</template>

<script>
    export default {
        name: "Register",
        props: {
            wrapperClass: {
                type: String,
                required: false,
                default: ''
            },
            textClasses: {
                type: String,
                required: false,
                default: ''
            },
            newCustomerUrl: {
                type: String,
                required: true
            },
        }
    }
</script>

<style scoped>

</style>
